import React from "react";
import { SignInWithGoogle } from "./SignInWithGoogle";
import { SignInWithMicrosoft } from "./SignInWithMicrosoft";

export const SocialSigninButtons = () => {
  return (
    <div className="mb-4 px-4 sm:px-16">
      <p className="text-sm text-gray-600 mb-4 text-center">Or sign in with</p>
      <div className="space-y-2">
        <SignInWithGoogle />
        <SignInWithMicrosoft />
      </div>
      <div className="relative mt-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-grey-light text-gray-500">or continue with email</span>
        </div>
      </div>
    </div>
  );
};
